export default "__VITE_ASSET__BLstUgfb__"